import { render } from "./HelpLinks.vue?vue&type=template&id=48431a1e"
import script from "./HelpLinks.vue?vue&type=script&lang=js"
export * from "./HelpLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/HelpLinks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "48431a1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('48431a1e', __exports__)) {
    api.reload('48431a1e', __exports__)
  }
  
  module.hot.accept("./HelpLinks.vue?vue&type=template&id=48431a1e", () => {
    api.rerender('48431a1e', render)
  })

}


export default __exports__